export default {
  url: process.env.VUE_APP_SERVER_URL
};
